import { useSelector } from 'react-redux';
import FlashMessage from '../../../components/flash-message';
import Tag from '../../../components/lozenge/tags';
import { PopoverContentWrapper } from '../../../components/modal/modal.styled';
import Spinners from '../../../components/spinner';
import Heading from '../../../components/typography';
import { ROLES_PERMISSION_LIST } from '../../../constants/common';
import { getFilteredPermissionData } from '../../../utils';
import { getPopoverGridSystemColumn, getPopoverGridSystemRow } from '../../../utils/global';
import { selectAuthRoutesList } from '../../configuration/routeSlice';
interface RolesPopoverContentType {
  permissionData: Record<string, boolean>;
  loading: boolean;
}

const RolesPopoverContent = ({ permissionData, loading }: RolesPopoverContentType): JSX.Element => {
  const userAuthList = useSelector(selectAuthRoutesList);
  const allFieldValues = userAuthList.localization?.values?.Wealthlane;
  console.log('roleover props', permissionData);

  const permissionsData = getFilteredPermissionData(permissionData);
  console.log('permission data', permissionsData);

  const { nonFieldLevelPermissionsGroups, fieldLevelPermissionsGroups } = permissionsData;
  const nonFieldGridRow = getPopoverGridSystemRow(Object.keys(nonFieldLevelPermissionsGroups)) ?? 1;
  const nonFieldGridColumn =
    getPopoverGridSystemColumn(Object.keys(nonFieldLevelPermissionsGroups)) ?? 1;

  const fieldGridRow = getPopoverGridSystemRow(Object.keys(fieldLevelPermissionsGroups)) ?? 1;
  const fieldGridColumn = getPopoverGridSystemColumn(Object.keys(fieldLevelPermissionsGroups)) ?? 1;

  return (
    <PopoverContentWrapper className='roles-popovers' id='actionsPopover'>
      {loading && <Spinners size='md' />}
      {!loading && Boolean(permissionsData) && (
        <>
          {Object.keys(nonFieldLevelPermissionsGroups).length > 0 ? (
            <div className='roles-popovers'>
              <Tag
                variant='info'
                title='Module Level Permission'
                className='tag'
                popoverClassName='roles-popovers'
              />
              <div
                className={`roles-popovers content grid gap-y-6 grid-cols-${nonFieldGridColumn} grid-rows-${nonFieldGridRow}`}>
                {Boolean(permissionsData) &&
                  Object.keys(nonFieldLevelPermissionsGroups).map((data: string) => {
                    const rolesInfo = nonFieldLevelPermissionsGroups[data].find(
                      (item: any) => item.text === 'View'
                    )?.key;

                    return (
                      <div className='content-info roles-popovers'>
                        <Heading
                          title={
                            Boolean(rolesInfo) && Boolean(allFieldValues)
                              ? allFieldValues[rolesInfo]
                              : '-'
                          }
                          variant='body-xs'
                          className='title roles-popovers'
                        />
                        <div className='flex roles-popovers'>
                          {nonFieldLevelPermissionsGroups[`${data}`]
                            .sort((a: any, b: any) => {
                              const A = a.text;
                              const B = b.text;
                              return ROLES_PERMISSION_LIST.indexOf(A) >
                                ROLES_PERMISSION_LIST.indexOf(B)
                                ? 1
                                : -1;
                            })
                            .map((itemData: any, index: number) => {
                              return (
                                <>
                                  <Heading
                                    title={itemData.text}
                                    variant='body-s'
                                    className='roles-popovers'
                                  />
                                  {
                                    <Heading
                                      title={
                                        nonFieldLevelPermissionsGroups[`${data}`].length !==
                                          index + 1 ? (
                                          <>
                                            {nonFieldLevelPermissionsGroups[`${data}`].length > 1 &&
                                              nonFieldLevelPermissionsGroups[`${data}`].length -
                                              2 !==
                                              index && (
                                                <span className='comma-text roles-popovers'>,</span>
                                              )}
                                          </>
                                        ) : (
                                          <>
                                            {nonFieldLevelPermissionsGroups[`${data}`].length ===
                                              1 && (
                                                <span className='only-text roles-popovers'>Only</span>
                                              )}
                                          </>
                                        )
                                      }
                                      variant='body-s'
                                      className='roles-popovers'
                                    />
                                  }
                                  {nonFieldLevelPermissionsGroups[`${data}`].length > 1 &&
                                    nonFieldLevelPermissionsGroups[`${data}`].length - 2 ===
                                    index && (
                                      <Heading
                                        title={
                                          <span className='comma-text only-text roles-popovers'>
                                            &
                                          </span>
                                        }
                                        variant='body-s'
                                        className='roles-popovers'
                                      />
                                    )}
                                </>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : null}
          {Object.keys(fieldLevelPermissionsGroups).length > 0 ? (
            <div className='roles-popovers'>
              <Tag
                variant='info'
                title='Field Level Permission'
                className='tag'
                popoverClassName='roles-popovers'
              />
              <div
                className={`roles-popovers content grid gap-y-6 grid-cols-${fieldGridColumn} grid-rows-${fieldGridRow}`}>
                {Boolean(permissionsData) &&
                  Object.keys(fieldLevelPermissionsGroups).map((data: string) => {
                    const rolesInfo = fieldLevelPermissionsGroups[data].find(
                      (item: any) => item.text === 'View'
                    )?.key;

                    return (
                      <div className='content-info roles-popovers'>
                        <Heading
                          title={
                            Boolean(rolesInfo) && Boolean(allFieldValues)
                              ? allFieldValues[rolesInfo]
                              : '-'
                          }
                          variant='body-xs'
                          className='title roles-popovers'
                        />
                        <div className='flex roles-popovers'>
                          {fieldLevelPermissionsGroups[`${data}`]
                            .sort((a: any, b: any) => {
                              const A = a.text;
                              const B = b.text;
                              return ROLES_PERMISSION_LIST.indexOf(A) >
                                ROLES_PERMISSION_LIST.indexOf(B)
                                ? 1
                                : -1;
                            })
                            .map((itemData: any, index: number) => {
                              return (
                                <>
                                  <Heading
                                    title={itemData.text}
                                    variant='body-s'
                                    className='roles-popovers'
                                  />
                                  {
                                    <Heading
                                      title={
                                        fieldLevelPermissionsGroups[`${data}`].length !==
                                          index + 1 ? (
                                          <>
                                            {fieldLevelPermissionsGroups[`${data}`].length > 1 &&
                                              fieldLevelPermissionsGroups[`${data}`].length - 2 !==
                                              index && (
                                                <span className='comma-text roles-popovers'>,</span>
                                              )}
                                          </>
                                        ) : (
                                          <>
                                            {fieldLevelPermissionsGroups[`${data}`].length ===
                                              1 && (
                                                <span className='only-text roles-popovers'>Only</span>
                                              )}
                                          </>
                                        )
                                      }
                                      variant='body-s'
                                      className='roles-popovers'
                                    />
                                  }
                                  {fieldLevelPermissionsGroups[`${data}`].length > 1 &&
                                    fieldLevelPermissionsGroups[`${data}`].length - 2 === index && (
                                      <Heading
                                        title={
                                          <span className='comma-text only-text roles-popovers'>
                                            &
                                          </span>
                                        }
                                        variant='body-s'
                                        className='roles-popovers'
                                      />
                                    )}
                                </>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : null}
        </>
      )}
      {!loading &&
        Boolean(permissionsData) &&
        Object.keys(nonFieldLevelPermissionsGroups).length === 0 &&
        Object.keys(fieldLevelPermissionsGroups).length === 0 && (
          <FlashMessage
            size='sm'
            message='No Data Found'
            type='info'
            popoverClassName='roles-popovers'
          />
        )}
    </PopoverContentWrapper>
  );
};

export default RolesPopoverContent;
